exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-out-of-stock[data-v-8e9cd99a]{pointer-events:none}.relative[data-v-8e9cd99a]{position:relative}.outof-stock-overlay[data-v-8e9cd99a]{position:absolute;width:100%;height:100%;left:0;top:0}.product-detail-wrapper .store-item img[data-v-8e9cd99a]{min-height:60px}", ""]);

// exports
